import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";

// Tone → colour. Accepts alert severity/status, collector status and signal levels.
const toneClass: Record<string, string> = {
  info: "bg-sky-500/15 text-sky-300",
  ok: "bg-sky-500/15 text-sky-300",
  warn: "bg-amber-500/15 text-amber-300",
  ack: "bg-amber-500/15 text-amber-300",
  disabled: "bg-amber-500/15 text-amber-300",
  critical: "bg-rose-500/15 text-rose-300",
  crit: "bg-rose-500/15 text-rose-300",
  open: "bg-rose-500/15 text-rose-300",
  error: "bg-rose-500/15 text-rose-300",
  closed: "bg-emerald-500/15 text-emerald-300",
  good: "bg-emerald-500/15 text-emerald-300",
  unknown: "bg-slate-800 text-slate-300",
};

// oltTone maps olt_devices.status so a degraded OLT (reachable, but its CLI
// output was not fully understood) is visibly distinct from an offline one.
export function oltTone(status?: string) {
  if (status === "reachable") return "good";
  if (status === "unreachable") return "crit";
  return "warn";
}

export default function StatusPill({ tone, children }: { tone?: string; children: ReactNode }) {
  const cls = toneClass[tone ?? ""] ?? toneClass.unknown;
  return (
    <Badge variant="outline" className={`rounded border-transparent uppercase tracking-wide ${cls}`}>
      {children}
    </Badge>
  );
}
